import fetch from 'node-fetch';
import createConfig from '../../config';

const getNavigation = async ({ id, depth = 3, subset = 'WEB' } = {}) => {
  const { urls } = createConfig();
  const idUrl = id ? `/${id}` : '';
  const uri = `${urls.base}/header/api/navigation${idUrl}?depth=${depth}&subset=${subset}`;
  const res = await fetch(uri, { credentials: 'include' });
  const json = await res.json();

  if (res.status !== 200) {
    return { error: json };
  }
  return json;
};

export default getNavigation;
